<template>
  <md-button @click="onClick" class="md-primary button">
    <slot />
  </md-button>
</template>

<script>
export default {
  name: 'PrimaryButton',
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
.md-primary.button {
  margin: 0;
  background: #ff5f3c;
  color: #fff;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 16px;
  height: 54px;
  border-radius: 30px;
}
</style>
